const gridAux = localStorage.getItem("grids");
const grids = gridAux ? JSON.parse(gridAux) : {};


export type State = {
  grids: any;
}

export const state: State = {
  grids: grids,
};